"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/source/VectorEventType
 */

/**
 * @enum {string}
 */
var _default = {
  /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */
  ADDFEATURE: 'addfeature',

  /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */
  CHANGEFEATURE: 'changefeature',

  /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */
  CLEAR: 'clear',

  /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */
  REMOVEFEATURE: 'removefeature',

  /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */
  FEATURESLOADSTART: 'featuresloadstart',

  /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */
  FEATURESLOADEND: 'featuresloadend',

  /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */
  FEATURESLOADERROR: 'featuresloaderror'
};
/**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2I7Ozs7O0VBS0FBLFVBQVUsRUFBRSxZQU5DOztFQVFiOzs7OztFQUtBQyxhQUFhLEVBQUUsZUFiRjs7RUFlYjs7Ozs7RUFLQUMsS0FBSyxFQUFFLE9BcEJNOztFQXNCYjs7Ozs7O0VBTUFDLGFBQWEsRUFBRSxlQTVCRjs7RUE4QmI7Ozs7O0VBS0FDLGlCQUFpQixFQUFFLG1CQW5DTjs7RUFxQ2I7Ozs7O0VBS0FDLGVBQWUsRUFBRSxpQkExQ0o7O0VBNENiOzs7OztFQUtBQyxpQkFBaUIsRUFBRTtBQWpETixDO0FBb0RmIiwibmFtZXMiOlsiQURERkVBVFVSRSIsIkNIQU5HRUZFQVRVUkUiLCJDTEVBUiIsIlJFTU9WRUZFQVRVUkUiLCJGRUFUVVJFU0xPQURTVEFSVCIsIkZFQVRVUkVTTE9BREVORCIsIkZFQVRVUkVTTE9BREVSUk9SIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zb3VyY2UvVmVjdG9yRXZlbnRUeXBlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19